import { useEffect, useState } from 'react';
import officeInfoService from '../../../services/OfficeInfoService';

export default function useFetchEmployeesPinCode() {
  const [employeesPinCodeLoading, setEmployeesPinCodeLoading] = useState(false);
  const [employeesPinCodeError, setEmployeesPinCodeError] = useState('');
  const [employeesPinCode, setEmployeesPinCode] = useState([]);

  useEffect(() => {
    const fetchEmployeesPinCode = async () => {
      try {
        setEmployeesPinCodeLoading(true);

        const pinCodeResponse = await officeInfoService.employeesPinCode();

        const pinCodes = pinCodeResponse?.data?.data;
        setEmployeesPinCode(Array.isArray(pinCodes) ? pinCodes : []);
      } catch (error) {
        setEmployeesPinCodeError(error?.message || 'Could not fetch employee records');
      } finally {
        setEmployeesPinCodeLoading(false);
      }
    };
    fetchEmployeesPinCode();
  }, []);

  return { employeesPinCode, setEmployeesPinCode, employeesPinCodeLoading, employeesPinCodeError };
}
